import { lazy, Suspense } from 'react';
import type { EChartsOption } from 'echarts';
import { useThemeMode } from '../../hooks/useThemeMode';

const ReactECharts = lazy(() => import('echarts-for-react'));

type AppChartProps = {
  option: EChartsOption;
  height?: number | string;
  className?: string;
};

export default function AppChart({
  option,
  height = 380,
  className,
}: AppChartProps) {
  const { isDark } = useThemeMode();

  return (
    <Suspense
      fallback={
        <div
          className="w-full rounded-xl border border-white/50 dark:border-white/10 bg-white/30 dark:bg-slate-900/30 animate-pulse"
          style={{ height }}
        />
      }
    >
      <ReactECharts
        option={option}
        notMerge
        lazyUpdate
        style={{ height, width: '100%' }}
        className={className}
        theme={isDark ? 'dark' : undefined}
      />
    </Suspense>
  );
}
